module.exports = __webpack_public_path__ + "public/images/about-netw-after.4248b98e9aff3d94ce757fcd6b6fa012.svg";